import React from 'react';

const TickerIcon = ({ name, className = '' }) => {
    const src = `/svgs/tickers/${name}.svg`;

    return (
        <img
            src={src}
            alt={`${name} logo`}
            className={`h-[30px] sm:h-[40px] md:h-[50px] lg:h-[60px] w-auto mx-8 ${className}`}
            onError={(e) => {
                e.target.style.display = 'none';
            }}
        />
    );
};

export default TickerIcon;
